__turbopack_context__.v({
  "root": "LoadingBlock-module__EFW_gG__root",
});
